<template>
  <div>
    <card v-for="f in this.prefs" :key="f.id" style="padding-bottom: 10px">
      <div slot="header" class="clearfix">
        <b>{{ f.name }}</b>
      </div>
      <div class="form-group">
        <n-checkbox
          v-for="t in f.types"
          :key="t.idTipoNotificacion"
          :id="'cbx_'+f.id+'_'+t.idTipoNotificacion"
          class="col-md-3 float-left"
          :checked="t.idPreferenciaNotificacion > 0 ? true : false"
          @change="getValue(t.idPreferenciaNotificacion, f.id, t.idTipoNotificacion, $event)">
          {{ t.tipoNotificacion }}
        </n-checkbox>
      </div>
    </card>
    <div class="col-md-12 text-center">
      <n-button type="primary" class="btn btn-sm" @click.native="savePref">
        {{ $t("app.buttons.save") }}
      </n-button>
    </div>
  </div>
</template>

<script>

export default {
  name: "preferenciasNotificaciones",
  components: {
    Card: () => import("@/components/Cards/Card.vue")
  },
  data(){
    return {
      prefs: [],
      fases: [],
      types: [],
      select: [],
      currPrefs: []
    }
  },
  async mounted() {
    this.$swal.fire({
      title: this.$t("app.promps.wait"),
      html:
        '<div class="spinner-border text-primary" style="width: 3rem; height: 3rem;" role="status"><span class="sr-only">Loading...</span></div>',
      showConfirmButton: false,
    });

    await this.getFases();
    await this.getTypes();
    await this.getPrefs();

    this.initControls();

    console.log(this.prefs);

    this.$swal.close();
  },
  methods: {
    async getFases() {
      const params = {
        id: this.$store.state.user.idUsuario,
        claveIdioma: this.$store.state.lang,
        usuario: this.$store.state.user.idUsuario,
      };

      await this.$http
        .post(route("Notificaciones/getFasesNotificacion"), params)
        .then(
          async (response) => {
            if (response.body.code === 200) {
              this.fases = response.body.valores;
              // console.log(this.fases);
            } else {
              this.notifyMessage("danger", this.$t("app.promps.error"));
              console.error(response.body.message);
            }
          },
          (error) => {
            this.notifyMessage("danger", this.$t("app.promps.error"));
            console.error(error);
          }
        );
    },
    async getTypes() {
      const params = {
        id: this.$store.state.user.idUsuario,
        claveIdioma: this.$store.state.lang,
        usuario: this.$store.state.user.idUsuario,
      };

      await this.$http
        .post(route("Notificaciones/GetTiposNotificaciones"), params)
        .then(
          async (response) => {
            if (response.body.code === 200) {
              this.types = response.body.tipoNotificacion;
              // console.log(this.types);
            } else {
              this.notifyMessage("danger", this.$t("app.promps.error"));
              console.error(response.body.message);
            }
          },
          (error) => {
            this.notifyMessage("danger", this.$t("app.promps.error"));
            console.error(error);
          }
        );
    },
    async getPrefs(){
      const params = {
        id: this.$store.state.user.idUsuario,
        claveIdioma: this.$store.state.lang,
        usuario: this.$store.state.user.idUsuario,
      };

      await this.$http
        .post(route("PreferenciaNotificacion/getPreferenciasNotificacion"), params)
        .then(
          async (response) => {
            if (response.body.code === 200) {
              this.currPrefs = response.body.preferencias;
              // console.log(this.currPrefs);
            } else {
              this.notifyMessage("danger", this.$t("app.promps.error"));
              console.error(response.body.message);
            }
          },
          (error) => {
            this.notifyMessage("danger", this.$t("app.promps.error"));
            console.error(error);
          }
        );
    },
    initControls(){
      for(let pf in this.fases){
        var ct = []
        for(let pt in this.types){
          var ipn = this.currPrefs
            .filter(cp => cp.fase == this.fases[pf].id && cp.notification == this.types[pt].idTipoNotificacion)[0];
          ct.push({
            idPreferenciaNotificacion: ipn != null ? ipn.idPreferenciaNotificacion : 0,
            idTipoNotificacion: this.types[pt].idTipoNotificacion,
            tipoNotificacion: this.types[pt].tipoNotificacion
          })
        }
        var cf = {
          id: this.fases[pf].id,
          name: this.fases[pf].name,
          types: ct
        }
        this.prefs.push(cf);
      }
    },
    getValue(idp, idf, idn, event) {
      // console.log(idf, idn, event);
      var sel = {
        preferencia: idp,
        notification: idn,
        fase: idf,
        usuario: this.$store.state.user.idUsuario,
        value: event
      }
      this.select.push(sel)
    },
    async savePref() {
      this.$swal.fire({
        title: this.$t("app.promps.wait"),
        html:
          '<div class="spinner-border text-primary" style="width: 3rem; height: 3rem;" role="status"><span class="sr-only">Loading...</span></div>',
        showConfirmButton: false,
      });

      console.log(this.select);
      var err = 0;
      for (let sel of this.select){
        if(sel.value){
          // Agregar
          if(sel.preferencia == 0){
            console.log("< < < AGREGANDO > > >")
            const addParams = {
              id: 0,
              claveIdioma: this.$store.state.lang,
              usuario: this.$store.state.user.idUsuario,
              preferencia: {
                idPreferenciaNotificacion: 0,
                notification: sel.notification,
                fase: sel.fase,
                usuario: sel.usuario
              }
            }

            await this.$http.post(route("PreferenciaNotificacion/postPreferenciaNotificacion"), addParams)
              .then(
                async (response) => {
                  if (response.body.code === 200) {
                    if(response.body.id < 1){
                      err++
                      console.error(response.body.message)
                    }
                  } else {
                    err++
                    console.error(response.body.message)
                  }
                },
                (error) => {
                  err++
                  console.error(error);
                }
              );
          }
        }
        else{
          // Quitar
          if(sel.preferencia > 0){
            console.log("< < < BORRANDO > > >")
            const delParams = {
              id: sel.preferencia,
              claveIdioma: this.$store.state.lang,
              usuario: this.$store.state.user.idUsuario
            }

            await this.$http.delete(route("PreferenciaNotificacion/deletePreferenciaNotificacion" + "?id=" + sel.preferencia))
              .then(
                async (response) => {
                  if (response.body.code === 200) {
                    if(response.body.id < 1){
                      err++
                      console.error(response.body.message)
                    }
                  } else {
                    err++
                    console.error(response.body.message)
                  }
                },
                (error) => {
                  err++
                  console.error(error);
                }
              );
          }
        }
      }
      if(err > 0){
        this.notifyMessage("danger", this.$t("app.promps.error"));
      }
      else{
        this.notifyMessage("success", this.$t("app.promps.save_success"));
      }

      this.$swal.close();
    },
  }
}
</script>

<style scoped>

</style>
